import { emit } from '../../platform/analytics/analytics'
import { envelopeStatus } from './budgetRules'
import type { BudgetField, BudgetPeriod, Envelope } from './budgetWire'
import type { BudgetFilter } from './budgetRules'

/** Counts, enums and booleans only — never an envelope name, a category name or an amount. */
export function emitViewed(envelopeCount: number, overCount: number, remainingDays: number): void {
  emit('budget_viewed', {
    envelope_count: envelopeCount,
    over_count: overCount,
    remaining_days: remainingDays,
  })
}

export function emitFilterChanged(filter: BudgetFilter): void {
  emit('budget_filter_changed', { budget_filter: filter })
}

/** Web creates monthly only, and `period`'s closed set spells that `month`. */
export function emitCreated(hasCategory: boolean): void {
  emit('budget_created', { category_present: hasCategory, period: 'month' })
}

/** One event per changed field. */
export function emitEdited(fields: readonly BudgetField[]): void {
  for (const f of fields) emit('budget_edited', { budget_field: f })
}

export function emitDeleted(): void {
  emit('budget_deleted', {})
}

/** `false` = paused, `true` = resumed. */
export function emitPaused(active: boolean): void {
  emit('budget_paused', { budget_active: active })
}

/** `period`'s closed set spells these week / month / year. Exhaustive, so a new period is a type error, not a slug. */
const PERIOD_SLUG: Record<BudgetPeriod, 'week' | 'month' | 'year'> = { weekly: 'week', monthly: 'month', yearly: 'year' }

/** The envelope detail opened. No name, id or amount: a status, a period, a boolean and a count. */
export function emitDetailViewed(envelope: Envelope, remainingDays: number): void {
  emit('budget_detail_viewed', {
    budget_state: envelopeStatus(envelope),
    period: PERIOD_SLUG[envelope.period],
    category_present: envelope.categoryId !== null,
    remaining_days: remainingDays,
  })
}
